/** Add-in release version. Reported to Sentry, Mixpanel, and LaunchDarkly. */
export const VERSION = "v7.1.4";
